import Navbar from "../Navbar";
import JungleScene from "./JungleScene";

/*
 * Shared page shell: jungle backdrop + canopy navbar + centred content column.
 * Every page renders inside this so the theme stays consistent.
 */
export default function Layout({ children, className = "" }) {
    return (
        <div className="app-shell">
            <JungleScene />
            <Navbar />
            <main className={className ? `page ${className}` : "page"}>{children}</main>
        </div>
    );
}
